import React, {FC, useContext} from 'react';
import {ModerationHint, ModerationRow} from "components";
import {Device, ModerationUser} from "interfaces";
import {ModerationSection} from "components/ModerationSection";
import {toDateString} from "utils";
import {Genders} from "enums";
import {AuthContext} from "contexts";
import {Envs} from "enums/Envs";
import {usersService} from "services";

interface Props {
    user: ModerationUser
    onUserChange: (user: ModerationUser) => void;
}

const isOlderThaniPhoneX = (deviceType: string) => {
    const regex = /^iPhone\s(\d+)/;
    const match = deviceType.match(regex);

    if (match) {
        const modelNumber = parseInt(match[1], 10);
        return modelNumber <= 8;
    }

    return false;
}

const isOlderThanVersion16 = (os: string) => {
    const [major] = os.split('.').map(Number);
    return major < 16;
}

export const ModerationDev: FC<Props> = ({user, onUserChange}) => {
    const devices = user.devices;

    const {env} = useContext(AuthContext);

    const hasDeviceWarning = (device: Device) => {
        return user.platform === 'IOS' && isOlderThanVersion16(device.os) && device.carrier === 'Unknown' && isOlderThaniPhoneX(device.deviceType)
    }

    const hasCarrierWarning = (device: Device) => {
        const isFemale = user.gender === Genders.Female;
        if (!isFemale) {
            return false;
        }

        return ['ng', 'ci', 'gh', 'ma', 'Unknown', 'MTN', 'MegaFon', 'MOOV AFRICA BJ', 'MTN Nigeria', 'MTN Benin', 'cellcard', 'MTN NG', 'MOOV BENIN', 'Airtel Nigeria', 'Metfone', 'EE'].findIndex(v => v === device.carrier) >= 0
    }

    const toggleTestUpgrade = async (key: string) => {
        if (!env) {
            return
        }

        const newUser = {
            id: user.id,
            testUpgrades: user.testUpgrades.map(tu => tu.name === key ? ({...tu, enabled: !tu.enabled}) : tu)
        };
        await usersService.update(newUser, env)
        onUserChange({
            ...user,
            ...newUser
        })
    }

    return <ModerationSection label="Приложение">
        <div className="row">
            <div className="col-12 col-xl-6">
                <ModerationRow label="Сессий" value={user.sessionNumber} isInsideTable/>
                <ModerationRow label="Версия" value={user.version} isInsideTable/>
                <ModerationRow label="Платформа" value={user.platform} isInsideTable/>
                <ModerationRow label="Логин" value={user.loginMethods?.join(', ')} isInsideTable/>
                <ModerationRow label="Нотификации" value={user.isPushNotificationEnabled ? 'Включены' : '-'}
                               isInsideTable/>
                {user.appFeatures && user.appFeatures.length > 0 &&
                    <ModerationRow label="Фичи" value={user.appFeatures.join(', ')} isInsideTable/>}
                {user.lastFcmTokenRefresh &&
                    <ModerationRow label="Обновление токена нотификаций"
                                   value={toDateString(user.lastFcmTokenRefresh, true)}
                                   isInsideTable/>}

                {env?.env === Envs.Test && user.testUpgrades && user.testUpgrades.length > 0 &&
                    <ModerationRow label="Тестовые улучшения"
                                   value={<>{user.testUpgrades.map(v =>
                                       (<div key={v.name}>
                                           {v.name}: <span className="fw-bold">{v.enabled ? 'on' : 'off'}</span>
                                           <a href="#" onClick={e => {
                                               e.preventDefault()
                                               toggleTestUpgrade(v.name)
                                           }} className="mx-2">Сменить</a>
                                       </div>))
                                   }</>}
                                   isInsideTable/>}
            </div>
            {devices && devices.length > 0 &&
                <div className="col-12 col-xl-6">
                    <div style={{fontWeight: 500}}>Утройства</div>
                    {devices.map((d, i) => {
                            const hasSuspiciousDeviceWarning = hasDeviceWarning(d.device);
                            const hasCarrierCountryWarning = hasCarrierWarning(d.device);
                            return <div key={d.device.deviceId + i}>
                                <ModerationRow
                                    label={d.lastActivityDate ? `${i + 1}. ${toDateString(d.lastActivityDate, false)}` : `(${i + 1})`}
                                    value={`${d.device.deviceType} (OS: ${d.device.os || '-'}, Сеть: ${d.device.carrier || '-'}, Локаль: ${d.device.regionCode || '-'})`}
                                    isInsideTable/>
                                {(hasSuspiciousDeviceWarning || hasCarrierCountryWarning) &&
                                    <ModerationHint>
                                        {hasSuspiciousDeviceWarning &&
                                            <div>Подозрительный девайс: старый, без сети и старая ось</div>}
                                        {hasCarrierCountryWarning &&
                                            <div>Подозрительная сеть <span className="fw-bold">{d.device.carrier}</span>:
                                                отсюда много скамеров
                                            </div>}
                                    </ModerationHint>}

                            </div>
                        }
                    )}
                </div>
            }
        </div>
    </ModerationSection>
};

